module.exports = __webpack_public_path__ + "media/images/new_landing/about/story-3-4d01b05fd0fc5d6f6de0e75a2c2a1b33.jpg";